import instoreCardsListModal from './instoreCardsListModal';

export default instoreCardsListModal;
